export default __webpack_public_path__ + "static/media/txt.416d70a9.svg";